import * as React from 'react';
import { TabTopPanel } from '../../../_components/TabTopPanel';

type CustomFormTabHeaderProps = {
    selectedTab:'answers' | 'overview',
    answerCount:number
    onClick?: (tabName: string) => void
}
export function CustomFormTabHeader(props:CustomFormTabHeaderProps):JSX.Element
{
    return (
        <TabTopPanel
            items={[
                    { tabName: 'answers', text: 'Besvarelser', avatarCount: props.answerCount },
                    { tabName: 'overview', text: 'Overblik', disabled: props.answerCount === 0 }
                ]}
            selectedTabName={props.selectedTab}
            onClick={(tabName) => props.onClick?.(tabName)} />
    );
}